<div class="container-fluid page">
  <div class="d-flex page__box p-3 mt-3 header" (click)="goback()">
    <span class="material-icons">admin_panel_settings</span> Data Engineering
  </div>
  <div class="container">

    <div class="box" (click)="goback()">App-{{this.config?.['cl_val']}}</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="pfflag">
      <line x1="2" y1="12" x2="16" y2="12" stroke="black" stroke-width="2" />
      <polygon points="16,6 22,12 16,18" fill="black" />
    </svg>
    <div class="box" *ngIf="pfflag" (click)="gobacktopfs()">PF-{{this.pfnode['label']}}</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="pfflag">
      <line x1="2" y1="12" x2="16" y2="12" stroke="black" stroke-width="2" />
      <polygon points="16,6 22,12 16,18" fill="black" />
    </svg>
    <div class="box" *ngIf="pfflag">LR-{{lrnode['di_bus_nm']}}</div>
  </div>
  <div class="mainpage">
    <div class="graphmain" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
      <button mat-button class="btn1" (click)="onSave()" *ngIf="keyflag">Save</button>
      <ngx-graph #graph [nodes]="nodes" [links]="edges" [autoZoom]="true" [enableZoom]="true" [showMiniMap]="true"
        [layout]="layout" [layoutSettings]="layoutSettings">
        <ng-template #defsTemplate>
          <svg:marker id="arrow" viewBox="0 -5 10 10" refX="8" refY="0" markerWidth="4" markerHeight="4" orient="auto">
            <svg:path d="M0,-5L10,0L0,5" class="arrow-head" />
          </svg:marker>
        </ng-template>
        <ng-template #clusterTemplate let-cluster>
          <svg:g class="node cluster">
            <svg:rect rx="200" ry="500" [attr.width]="cluster.dimension.width" [attr.height]="cluster.dimension.height"
              [attr.fill]="cluster.data.color" />
          </svg:g>
        </ng-template>
        <ng-template #nodeTemplate let-node>
          <svg:g class="node">
            <svg:g *ngIf="node.type === 'application'">
              <svg:rect [attr.width]="200" height="20" fill="rgb(168, 56, 93)" stroke="rgb(168, 56, 93)"
                stroke-width="2" />


              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="20" height="20" fill="none" viewBox="0 0 24 24">
                <path stroke="white" fill-rule="evenodd"
                  d="M4.857 3A1.857 1.857 0 0 0 3 4.857v4.286C3 10.169 3.831 11 4.857 11h4.286A1.857 1.857 0 0 0 11 9.143V4.857A1.857 1.857 0 0 0 9.143 3H4.857Zm10 0A1.857 1.857 0 0 0 13 4.857v4.286c0 1.026.831 1.857 1.857 1.857h4.286A1.857 1.857 0 0 0 21 9.143V4.857A1.857 1.857 0 0 0 19.143 3h-4.286Zm-10 10A1.857 1.857 0 0 0 3 14.857v4.286C3 20.169 3.831 21 4.857 21h4.286A1.857 1.857 0 0 0 11 19.143v-4.286A1.857 1.857 0 0 0 9.143 13H4.857ZM18 14a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z"
                  clip-rule="evenodd" />
              </svg>

              <svg:text x="40" y="15" fill="#ffffff">{{ node.cd }}</svg:text>
              <svg:g (click)="showFiles(node)">
                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                  width="370" height="20" fill="none" viewBox="0 0 24 24">
                  <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m9 5 7 7-7 7" />
                </svg>
              </svg:g>
              <svg:rect y="20" [attr.width]="200" height="70" fill="#ffffff" stroke="rgb(168, 56, 93)"
                stroke-width="2" />
              <svg width="200" height="100" xmlns="http://www.w3.org/2000/svg">
                <foreignObject x="10" y="30" width="180" height="50">
                  <div xmlns="http://www.w3.org/1999/xhtml" style="font-size: 10px;">
                    {{ node.label }}
                  </div>
                </foreignObject>
              </svg>
              <svg:text x="10" y="80" fill="#000000" font-size="10px">Type: {{ node.type }}</svg:text>
              <svg:text x="180" y="80" fill="#000000" font-size="20px">&hellip;</svg:text>
              <foreignObject x="190" y="90" width="120" height="60">
              </foreignObject>
            </svg:g>
            <svg:g *ngIf="node.type === 'Physical File'" (mousedown)="onNodeCircleMouseDown($event, node)">
              <svg:rect [attr.width]="250" height="20"    [attr.fill]="getColorForPath(node?.referData?.di_tcd_json?.pf_path)"
              [attr.stroke]="getColorForPath(node?.referData?.di_tcd_json?.pf_path)" stroke-width="2"
                (click)="toggleTermsVisibility(node)" />
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="20" height="20" fill="none" viewBox="0 0 24 24">
                <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 6h8m-8 6h8m-8 6h8M4 16a2 2 0 1 1 3.321 1.5L4 20h5M4 5l2-1v6m-2 0h4" />
              </svg>
              <svg:text x="40" y="15" fill="#ffffff">{{node?.referData?.di_tcd_json?.pf_path}}.{{ node.cd}}</svg:text>
              <svg:g>
                <svg *ngIf="!node.showTerms" class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="450" height="20" fill="none" viewBox="0 0 24 24">
                  <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 5v14m-7-7h14" />
                </svg>
                <svg *ngIf="node.showTerms" class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="450" height="20" viewBox="0 0 24 24" fill="none">
                  <path stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M5 12h14">
                  </path>
                </svg>
                <svg:rect x="250" y="0" width="30" height="20" fill="#fdde6c"   [attr.stroke]="getColorForPath(node?.referData?.di_tcd_json?.pf_path)"  stroke-width="2" />
                <svg:text x="255" y="15" fill="black" font-size="20px" [matMenuTriggerFor]="menu">&hellip;</svg:text>
                <foreignObject x="200" y="20" width="120" height="60">
                  <mat-menu #menu="matMenu" xPosition="after" yPosition="below">
                    <button mat-menu-item class="menu-item" (click)="update('PF', node, 'view')">
                      <mat-icon class="menu-icon">visibility</mat-icon>
                      <span>View</span>
                    </button>
                    <button mat-menu-item class="menu-item" (click)="update('PF', node, 'update')">
                      <mat-icon class="menu-icon">edit</mat-icon>
                      <span>Modify</span>
                    </button>
                    <button mat-menu-item class="menu-item" (click)="addterms(node)">
                      <mat-icon class="menu-icon">settings</mat-icon>
                      <span>Manage</span>
                    </button>
                    <button mat-menu-item class="menu-item" (click)="deletepf(node)">
                      <mat-icon class="menu-icon">delete</mat-icon>
                      <span>Remove</span>
                    </button>
                  </mat-menu>
                </foreignObject>
              </svg:g>
              <svg:g *ngIf="node.showTerms">
                <svg:rect y="20" [attr.width]="250" [attr.height]="calculateSVGHeight(node)" fill="#ffffff"
                [attr.stroke]="getColorForPath(node?.referData?.di_tcd_json?.pf_path)"  stroke-width="2" />
                <svg width="250" [attr.height]="calculateSVGHeight(node)" xmlns="http://www.w3.org/2000/svg">
                  <foreignObject x="10" y="30" width="230" [attr.height]="calculateSVGHeight(node)">
                    <div xmlns="http://www.w3.org/1999/xhtml" style="font-size: small;">
                      <div *ngFor="let term of phytermsarr[node.id]">
                        <span>{{ term['di_tech_nm'] }}</span>
                        <span style="float: right;">{{ term['di_tcd_json']['data_type']['dt_tcd']}}
                          <svg xmlns="http://www.w3.org/2000/svg" x="120" y="70" width="15" height="15"
                            viewBox="0 0 48 48" *ngIf="term['isPrimary']">
                            <path fill="#FF0000"
                              d="M30 41L26 45 22 45 18 41 18 21 30 21 30 29 28 31 30 33 30 35 28 37 30 39z"></path>
                            <path fill="#FF0000"
                              d="M38,7.8C37.5,6,36,4.7,34.3,4.2C31.9,3.7,28.2,3,24,3s-7.9,0.7-10.3,1.2C12,4.7,10.5,6,10,7.8c-0.5,1.7-1,4.1-1,6.7c0,2.6,0.5,5,1,6.7c0.5,1.8,1.9,3.1,3.7,3.5C16.1,25.3,19.8,26,24,26s7.9-0.7,10.3-1.2c1.8-0.4,3.2-1.8,3.7-3.5c0.5-1.7,1-4.1,1-6.7C39,11.9,38.5,9.5,38,7.8z M29,13H19c-1.1,0-2-0.9-2-2V9c0-0.6,3.1-1,7-1s7,0.4,7,1v2C31,12.1,30.1,13,29,13z">
                            </path>
                            <path fill="#FF0000" d="M23 26H25V45H23z"></path>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" x="140" y="70" width="15" height="15"
                            viewBox="0 0 48 48" *ngIf="term['isUnique']">
                            <path fill="#33A1FF"
                              d="M30 41L26 45 22 45 18 41 18 21 30 21 30 29 28 31 30 33 30 35 28 37 30 39z"></path>
                            <path fill="#33A1FF"
                              d="M38,7.8C37.5,6,36,4.7,34.3,4.2C31.9,3.7,28.2,3,24,3s-7.9,0.7-10.3,1.2C12,4.7,10.5,6,10,7.8c-0.5,1.7-1,4.1-1,6.7c0,2.6,0.5,5,1,6.7c0.5,1.8,1.9,3.1,3.7,3.5C16.1,25.3,19.8,26,24,26s7.9-0.7,10.3-1.2c1.8-0.4,3.2-1.8,3.7-3.5c0.5-1.7,1-4.1,1-6.7C39,11.9,38.5,9.5,38,7.8z M29,13H19c-1.1,0-2-0.9-2-2V9c0-0.6,3.1-1,7-1s7,0.4,7,1v2C31,12.1,30.1,13,29,13z">
                            </path>
                            <path fill="#33A1FF" d="M23 26H25V45H23z"></path>
                          </svg>

                          <svg xmlns="http://www.w3.org/2000/svg" x="160" y="70" width="15" height="15"
                            viewBox="0 0 48 48" *ngIf="term['isForeign']">
                            <path fill="#F6BE00"
                              d="M30 41L26 45 22 45 18 41 18 21 30 21 30 29 28 31 30 33 30 35 28 37 30 39z"></path>
                            <path fill="#F6BE00"
                              d="M38,7.8C37.5,6,36,4.7,34.3,4.2C31.9,3.7,28.2,3,24,3s-7.9,0.7-10.3,1.2C12,4.7,10.5,6,10,7.8c-0.5,1.7-1,4.1-1,6.7c0,2.6,0.5,5,1,6.7c0.5,1.8,1.9,3.1,3.7,3.5C16.1,25.3,19.8,26,24,26s7.9-0.7,10.3-1.2c1.8-0.4,3.2-1.8,3.7-3.5c0.5-1.7,1-4.1,1-6.7C39,11.9,38.5,9.5,38,7.8z M29,13H19c-1.1,0-2-0.9-2-2V9c0-0.6,3.1-1,7-1s7,0.4,7,1v2C31,12.1,30.1,13,29,13z">
                            </path>
                            <path fill="#F6BE00" d="M23 26H25V45H23z"></path>
                          </svg>
                        </span>
                        <hr style="margin: 4px 0; border: none; border-top: 1px solid black;">
                      </div>
                    </div>
                  </foreignObject>
                </svg>
              </svg:g>
              <svg xmlns="http://www.w3.org/2000/svg" x="115" y="-30" width="30" height="30" viewBox="0 0 24 24"   (click)="selfreference(node)">
                <circle cx="15" cy="15" r="15" fill="#fdde6c" />
                <path fill="none" stroke="white" stroke-width="2" d="M12 8 L12 16 M8 12 L12 8 L16 12" />
              </svg>
              
            </svg:g>
            <svg:g *ngIf="node.type === 'Logical Record'">
              <svg:rect [attr.width]="200" height="20" fill="#695E93" stroke="#695E93" stroke-width="2"
                (click)="toggleTermsVisibility(node)" />
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="20" height="20" fill="none" viewBox="0 0 24 24">
                <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 6h8m-8 6h8m-8 6h8M4 16a2 2 0 1 1 3.321 1.5L4 20h5M4 5l2-1v6m-2 0h4" />
              </svg>
              <svg:text x="40" y="15" fill="#ffffff" class="dynamic-label">{{ truncateLabel(node.label, 18) }}
              </svg:text>
              <svg:g>
                <svg *ngIf="!node.showTerms" class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="370" height="20" fill="none" viewBox="0 0 24 24">
                  <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 5v14m-7-7h14" />
                </svg>

                <svg *ngIf="node.showTerms" class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="370" height="20" viewBox="0 0 24 24" fill="none">
                  <path stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M5 12h14">
                  </path>
                </svg>
                <svg:rect x="200" y="0" width="30" height="20" fill="#fdde6c" stroke="#695E93" stroke-width="2" />
                <svg:text x="205" y="15" fill="black" font-size="20px" [matMenuTriggerFor]="menu">&hellip;</svg:text>
                <foreignObject x="200" y="20" width="120" height="60">
                  <mat-menu #menu="matMenu" xPosition="after" yPosition="below">
                    <button mat-menu-item class="menu-item">
                      <mat-icon class="menu-icon">visibility</mat-icon>
                      <span>View</span>
                    </button>
                    <button mat-menu-item class="menu-item">
                      <mat-icon class="menu-icon">edit</mat-icon>
                      <span>Update</span>
                    </button>
                  </mat-menu>
                </foreignObject>
              </svg:g>
              <svg:g *ngIf="node.showTerms">
                <svg:rect y="20" [attr.width]="230" [attr.height]="calculateSVGHeight(node)" fill="#ffffff"
                  stroke="#695E93" stroke-width="2" />
                <svg width="230" [attr.height]="calculateSVGHeight(node)" xmlns="http://www.w3.org/2000/svg">
                  <foreignObject x="10" y="30" width="210" [attr.height]="calculateSVGHeight(node)">
                    <div xmlns="http://www.w3.org/1999/xhtml" style="font-size: 10px;">

                      <div *ngFor="let term of phytermsarr[node.id]" (click)="delete(node,term)"
                        style="cursor: pointer;">
                        <svg:rect x="190" y="0" width="30" height="20" fill="#fdde6c" stroke="#695E93"
                          stroke-width="2" />
                        <span>{{ term['di_tech_nm'] }}</span>
                        <span style="float: right;">{{ term['di_tcd_json']['data_type']['dt_tcd']}}
                          <svg xmlns="http://www.w3.org/2000/svg" x="120" y="70" width="15" height="15"
                            viewBox="0 0 48 48" *ngIf="term['isPrimary']">
                            <path fill="#FF0000"
                              d="M30 41L26 45 22 45 18 41 18 21 30 21 30 29 28 31 30 33 30 35 28 37 30 39z"></path>
                            <path fill="#FF0000"
                              d="M38,7.8C37.5,6,36,4.7,34.3,4.2C31.9,3.7,28.2,3,24,3s-7.9,0.7-10.3,1.2C12,4.7,10.5,6,10,7.8c-0.5,1.7-1,4.1-1,6.7c0,2.6,0.5,5,1,6.7c0.5,1.8,1.9,3.1,3.7,3.5C16.1,25.3,19.8,26,24,26s7.9-0.7,10.3-1.2c1.8-0.4,3.2-1.8,3.7-3.5c0.5-1.7,1-4.1,1-6.7C39,11.9,38.5,9.5,38,7.8z M29,13H19c-1.1,0-2-0.9-2-2V9c0-0.6,3.1-1,7-1s7,0.4,7,1v2C31,12.1,30.1,13,29,13z">
                            </path>
                            <path fill="#FF0000" d="M23 26H25V45H23z"></path>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" x="140" y="70" width="15" height="15"
                            viewBox="0 0 48 48" *ngIf="term['isUnique']">
                            <path fill="#33A1FF"
                              d="M30 41L26 45 22 45 18 41 18 21 30 21 30 29 28 31 30 33 30 35 28 37 30 39z"></path>
                            <path fill="#33A1FF"
                              d="M38,7.8C37.5,6,36,4.7,34.3,4.2C31.9,3.7,28.2,3,24,3s-7.9,0.7-10.3,1.2C12,4.7,10.5,6,10,7.8c-0.5,1.7-1,4.1-1,6.7c0,2.6,0.5,5,1,6.7c0.5,1.8,1.9,3.1,3.7,3.5C16.1,25.3,19.8,26,24,26s7.9-0.7,10.3-1.2c1.8-0.4,3.2-1.8,3.7-3.5c0.5-1.7,1-4.1,1-6.7C39,11.9,38.5,9.5,38,7.8z M29,13H19c-1.1,0-2-0.9-2-2V9c0-0.6,3.1-1,7-1s7,0.4,7,1v2C31,12.1,30.1,13,29,13z">
                            </path>
                            <path fill="#33A1FF" d="M23 26H25V45H23z"></path>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" x="160" y="70" width="15" height="15"
                            viewBox="0 0 48 48" *ngIf="term['isIndex']">
                            <path fill="#33FF57"
                              d="M30 41L26 45 22 45 18 41 18 21 30 21 30 29 28 31 30 33 30 35 28 37 30 39z"></path>
                            <path fill="#33FF57"
                              d="M38,7.8C37.5,6,36,4.7,34.3,4.2C31.9,3.7,28.2,3,24,3s-7.9,0.7-10.3,1.2C12,4.7,10.5,6,10,7.8c-0.5,1.7-1,4.1-1,6.7c0,2.6,0.5,5,1,6.7c0.5,1.8,1.9,3.1,3.7,3.5C16.1,25.3,19.8,26,24,26s7.9-0.7,10.3-1.2c1.8-0.4,3.2-1.8,3.7-3.5c0.5-1.7,1-4.1,1-6.7C39,11.9,38.5,9.5,38,7.8z M29,13H19c-1.1,0-2-0.9-2-2V9c0-0.6,3.1-1,7-1s7,0.4,7,1v2C31,12.1,30.1,13,29,13z">
                            </path>
                            <path fill="#33FF57" d="M23 26H25V45H23z"></path>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" x="160" y="70" width="15" height="15"
                            viewBox="0 0 48 48" *ngIf="term['isForeign']">
                            <path fill="#F6BE00"
                              d="M30 41L26 45 22 45 18 41 18 21 30 21 30 29 28 31 30 33 30 35 28 37 30 39z"></path>
                            <path fill="#F6BE00"
                              d="M38,7.8C37.5,6,36,4.7,34.3,4.2C31.9,3.7,28.2,3,24,3s-7.9,0.7-10.3,1.2C12,4.7,10.5,6,10,7.8c-0.5,1.7-1,4.1-1,6.7c0,2.6,0.5,5,1,6.7c0.5,1.8,1.9,3.1,3.7,3.5C16.1,25.3,19.8,26,24,26s7.9-0.7,10.3-1.2c1.8-0.4,3.2-1.8,3.7-3.5c0.5-1.7,1-4.1,1-6.7C39,11.9,38.5,9.5,38,7.8z M29,13H19c-1.1,0-2-0.9-2-2V9c0-0.6,3.1-1,7-1s7,0.4,7,1v2C31,12.1,30.1,13,29,13z">
                            </path>
                            <path fill="#F6BE00" d="M23 26H25V45H23z"></path>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" x="200" y="0" width="15" height="15"
                            viewBox="0 0 24 24" fill="red">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path
                              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                          </svg>
                        </span>

                        <hr style="margin: 4px 0; border: none; border-top: 1px solid black;">
                      </div>
                    </div>
                  </foreignObject>
                </svg>

              </svg:g>

            </svg:g>
            <svg:g *ngIf="node.type === 'Business Term'" (click)="toggleTermSelection(node.techNm)">
              <svg:rect [attr.width]="200" height="20" fill="rgb(80, 171, 204)" stroke="rgb(80, 171, 204)"
                stroke-width="2" />

              <svg:circle cx="200" cy="5" r="15" fill="#9A2A2A" stroke="white" stroke-width="2"
                (click)="removeNode(node)" />
              <svg class="minus-icon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" x="190" y="-5" width="20"
                height="20" fill="white" viewBox="0 0 24 24">
                <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
              </svg>
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="20" height="20" fill="none" viewBox="0 0 24 24" x="20" y="3">
                <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M10 3v4a1 1 0 0 1-1 1H5m4 10v-2m3 2v-6m3 6v-3m4-11v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z" />
              </svg>
              <svg:rect [attr.width]="15" height="15" [attr.fill]="isSelected(node.techNm) ? 'blue' : 'white'" x="2"
                y="3" stroke="black" stroke-width="1" *ngIf="keyflag" />
              <svg:text x="40" y="15" fill="#ffffff">{{ node.id }}</svg:text>
              <svg:rect y="20" [attr.width]="200" height="70" fill="#ffffff" stroke="rgb(80, 171, 204)"
                stroke-width="2" />
              <svg width="200" height="100" xmlns="http://www.w3.org/2000/svg">
                <foreignObject x="10" y="30" width="180" height="50">
                  <div xmlns="http://www.w3.org/1999/xhtml" style="font-size: 10px;">
                    {{ node.label }}
                  </div>
                </foreignObject>
              </svg>
              <svg:text x="10" y="80" fill="#000000" font-size="10px">{{ node.type }}</svg:text>
              <svg:text x="180" y="80" fill="#000000" font-size="20px">&hellip;</svg:text>

            </svg:g>
          </svg:g>
        </ng-template>

      <ng-template #linkTemplate let-link>
  <svg:g class="edge" [matMenuTriggerFor]="link.data != 'crossrelation' ? edgeMenu : null">
    <svg:defs>
      <svg:marker
        [attr.id]="'arrow-' + link.id"
        viewBox="0 0 10 10"
        refX="9"
        refY="5"
        markerWidth="6"
        markerHeight="6"
        orient="auto"
      >
        <svg:path d="M 0 0 L 10 5 L 0 10 z" fill="orange" />
      </svg:marker>
    </svg:defs>

    <svg:path
      class="line"
      [ngClass]="{'FILETOFILE': link.data === 'FILETOFILE'}"
      stroke-width="2"
      stroke="#50C878"
      fill="none"
      [attr.marker-end]="'url(#arrow-' + link.id + ')'"
      [attr.d]="link.path"
    ></svg:path>

    <svg:text class="edge-label" text-anchor="middle">
      <textPath
        class="text-path"
        [attr.href]="'#' + link.id"
        [style.dominant-baseline]="link.dominantBaseline"
        startOffset="70%"
        style="font-weight:600;color: black;"
      >
        {{ link.label }}
      </textPath>
    </svg:text>

    <svg:foreignObject>
      <mat-menu #edgeMenu="matMenu" xPosition="after" yPosition="below">
        <button mat-menu-item (click)="deleteasc(link)">
          <mat-icon>delete</mat-icon>
          <span>Remove</span>
        </button>
        <button mat-menu-item (click)="updateasc(link)">
          <mat-icon>edit</mat-icon>
          <span>Update</span>
        </button>
      </mat-menu>
    </svg:foreignObject>
  </svg:g>
</ng-template>

      </ngx-graph>
    </div>
    <div class="container-box">
      <div class="color-code-index">
        <div class="color-code primary-key">Primary Key</div>
        <div class="color-code unique-key">Unique Key</div>
        <div class="color-code index-key">Index Key</div>
        <div class="color-code foreign-key">Foreign Key</div>
      </div>

      <div class=" page__box p-1 mt-1 header">
        <span class="material-icons">
          drag_indicator
        </span> Inventory
      </div>
      <hr>
      <!-- <mat-slide-toggle *ngIf="ascflag" #toggleElement (change)="onCheckboxChange($event)" class="sub-header">Show
        Associations
      </mat-slide-toggle> -->
      <div class="select-container">
        <ng-select placeholder="Select" style="font-size:small ;width: 90%;" [(ngModel)]="selectedtype"
          (change)="getItems(selectedtype)">
          <ng-option *ngFor="let item of clArr" [value]="item.cl_cd">{{item.cl_val}}</ng-option>
        </ng-select>

   
        <button class="button-add  mat-button btn-primary" *ngIf="showbox && selectedtype!='RL'" (click)=onAddButtonClick()>Add</button>
      </div>
      <ng-select placeholder="Filter By App" style="font-size:small ;width: 90%;" [(ngModel)]="selectedcl"
      (change)="filtercl(selectedcl)"  *ngIf="selectedtype=='RL'">
      <ng-option *ngFor="let item of allapps" [value]="item.cl_cd" style="font-size:x-small ">{{item.cl_val}}</ng-option>
    </ng-select>
      <br>
      <div *ngIf="showbox">
        <div class="search-container">
          <i class="fa fa-search search-icon"></i>
          <input type="text" [(ngModel)]="searchTerm" (input)="applyFilter()" placeholder="Search..."
            class="search-input">
        </div>
        <br>
        <div class="term-box">
          <div class="application-node" *ngFor="let item of filteredItems" draggable="true"
            (dragstart)="onDragStart($event,item)" (dragend)="onDragEnd($event)"
            [matMenuTriggerFor]="item?.di_tcd == 'TR' ? menu : null">
            <div class="rect" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
              <i class="fa fa-file-text" aria-hidden="true" style="margin-right: 3px;"></i>
              {{item?.di_tech_nm}}-{{item?.di_bus_nm}}


            </div>
            <mat-menu #menu="matMenu" xPosition="before" yPosition="below">
              <!-- <button mat-menu-item class="menu-item" (click)="update('TR',item , 'view')">
                <mat-icon class="menu-icon">visibility</mat-icon>
                <span>View</span>
              </button> -->
              <button mat-menu-item class="menu-item" (click)="update('TR', item, 'update')">
                <mat-icon class="menu-icon">edit</mat-icon>
                <span>Update</span>
              </button>

              <button mat-menu-item class="menu-item" (click)="deleteterm(item)">
                <mat-icon class="menu-icon">delete</mat-icon>
                <span>Delete</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal" [class.show]="isModalVisible">
  <div class="modal-content">
    <span class="close" (click)="closeModal()">&times;</span>
    <h1 mat-dialog-title class="header"><i class="fa fa-pencil"></i> Manage Relationship </h1>

    <div class="mat-dialog-content1">
      <ng-select placeholder="Primary Key for {{relobj?.['name']}}" [(ngModel)]="relobj['primary_key']">
        <ng-option *ngFor="let item of pkarr" [value]="item">{{item}}</ng-option>
      </ng-select>
      <ng-select placeholder="Select Relationship Type" [(ngModel)]="relobj['rel']">
        <ng-option *ngFor="let item of relarr" [value]="item.code">{{item.value}}</ng-option>
      </ng-select>
      <ng-select placeholder="Select Foreign Key" [(ngModel)]="relobj['foreign_key']" *ngIf="relobj['rel']!='M-M'">
        <ng-option *ngFor="let item of fkarr" [value]="item.di_tech_nm">{{item.di_tech_nm}}</ng-option>
      </ng-select>
      <div *ngIf="relobj['rel']=='M-M'">
        <ng-select placeholder="Select  the cross-reference table:" [(ngModel)]="relobj['cross_pf']"
          (change)="getcolumns(relobj['cross_pf'])">
          <ng-option *ngFor="let item of pfs" [value]="item.di_tech_nm">{{item.di_tech_nm}}</ng-option>
        </ng-select>
        <ng-select placeholder="Select Column for  {{relobj?.['name']}}'s foreign key:" [(ngModel)]="relobj['fkenta']">
          <ng-option *ngFor="let item of crossfkar" [value]="item['di_tech_nm']">{{item.di_tech_nm}}-{{item.di_bus_nm}}
          </ng-option>
        </ng-select>
        <ng-select placeholder="Select Column for  {{relobj?.['nameb']}}'s foreign key:" [(ngModel)]="relobj['fkentb']">
          <ng-option *ngFor="let item of crossfkar" [value]="item['di_tech_nm']">{{item.di_tech_nm}}-{{item.di_bus_nm}}
          </ng-option>
        </ng-select>
      </div>
    </div>
    <button type="button" class="btn1" *ngIf="!modalup" (click)="submitRelationship()">Submit</button>
    <button type="button" class="btn1" *ngIf="modalup" (click)="updateRelationship()">Update</button>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0.6)"
  size="medium"
  color="#00ffcc"
  type="ball-scale-multiple"
  [fullScreen]="true"
>
  <p style="color: white; font-size: 1.1rem; margin-top: 10px;">
    <mat-icon style="vertical-align: middle; color:#00ffcc;">sync</mat-icon>
    Loading... please wait
  </p>
</ngx-spinner>

